import { render, staticRenderFns } from "./TaxesSelect.vue?vue&type=template&id=f40de610&scoped=true&"
import script from "./TaxesSelect.vue?vue&type=script&lang=js&"
export * from "./TaxesSelect.vue?vue&type=script&lang=js&"
import style0 from "./TaxesSelect.vue?vue&type=style&index=0&id=f40de610&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40de610",
  null
  
)

export default component.exports